let getModule = () => {
	return import(/* webpackChunkName: "controlsIssueDetails" */ './IssuesDetails').then((module) => {
		return module;
	});
}

(function (qdesk) {
	qdesk.imagePreview = function (element?: HTMLElement) {
		getModule()
			.then(m => m.imagePreview(element))
			.catch(error => console.error(error));
	}

	qdesk.attachmentPreview = function () {
		getModule()
			.then(m => m.attachmentPreview())
			.catch(error => console.error(error));
	}

	qdesk.noteCommentInit = function () {
		var noteCommentsElement = document.getElementById("react-note-comments-app");
		if (noteCommentsElement) {
			getModule()
				.then(m => m.initNoteComments(noteCommentsElement))
				.catch(error => console.error(error));
		}
	}

}((window as any).qdesk = (window as any).qdesk || {}));

export default function Init(rootElement?: HTMLElement) {
	var nodes = (rootElement || document).querySelectorAll(".react-comments, .react-attachments");
	if (nodes.length != 0) {
		getModule().then(module => {
			for (let i = 0; i < nodes.length; i++) {
				let node = nodes[i] as HTMLElement;
				if (node.classList.contains("react-comments")) {
					module.initNoteComments(node);
				}
				if (node.classList.contains("react-attachments")) {
					module.renderAttachments(node);
				}

			}
		})
		.catch(error => console.error(error));
	}
}